export enum ModuleCodeGuard {
    BILLING_CODE = 'configuration.parameter.laboratory.module.billing.active',
    REQUESTS_CODE = 'configuration.parameter.laboratory.module.registry.request.active'
}
